const paymentTypes = {
  CARD: "Bank card",
  CHECK: "Check",
  WIRE: "Wire Transfer",
};

export default paymentTypes;
